import { Link } from "react-router-dom";
import { BOOKING_URL } from "../config";

export const BookLink = ({ className = "", children, ...rest }) => {
    if (BOOKING_URL) {
        return (
            <a href={BOOKING_URL} target="_blank" rel="noreferrer" className={className} {...rest}>
                {children}
            </a>
        );
    }
    return (
        <Link to="/contact" className={className} {...rest}>
            {children}
        </Link>
    );
};
